'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notificationsReadySelector = exports.errorNotificationUserIds = exports.getNotificationUserResources = exports.notificationUsersSelector = exports.notificationUserIdsSelector = exports.activeNotificationsIdsSelector = exports.notificationsCountSelector = exports.activeNotificationsSelector = exports.modifiedElementsSelector = exports.getForcedPoll = exports.getFetchedTime = undefined;

var _reselect = require('reselect');

var _milanoteReselect = require('../utils/milanoteReselect/milanoteReselect');

var _resourceUtil = require('../utils/services/http/resources/resourceUtil');

var _usersSelector = require('../user/usersSelector');

var _immutableHelper = require('../../common/utils/immutableHelper');

// Utils
var getFetchedTime = exports.getFetchedTime = function getFetchedTime(state) {
    return state.getIn(['notifications', 'fetchedTime']);
}; // Lib
var getForcedPoll = exports.getForcedPoll = function getForcedPoll(state) {
    return state.getIn(['notifications', 'forcedPoll']);
};

var modifiedElementsSelector = exports.modifiedElementsSelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['notifications', 'modifiedElements']);
}, function (modifiedElements) {
    return modifiedElements.sort(function (messageA, messageB) {
        return messageB.get('modifiedTime') - messageA.get('modifiedTime');
    });
});

var activeNotificationsSelector = exports.activeNotificationsSelector = (0, _reselect.createSelector)(modifiedElementsSelector, function (state) {
    return state.getIn(['app', 'currentUser', 'viewedBoards']);
}, function (state) {
    return state.getIn(['app', 'currentUser', 'lastCheckedNotifications']);
}, function (modifiedElements, viewedBoards, lastCheckedNotifications) {
    return modifiedElements.filter(function (notification) {
        return notification.get('active');
    }).filter(function (notification) {
        return !viewedBoards.get(notification.get('id')) || viewedBoards.get(notification.get('id')) < notification.get('modifiedTime');
    });
});

var notificationsCountSelector = exports.notificationsCountSelector = (0, _reselect.createSelector)(activeNotificationsSelector, function (state) {
    return state.getIn(['app', 'currentUser', 'lastCheckedNotifications']);
}, function (activeNotifications, lastCheckedNotifications) {
    return activeNotifications.filter(function (notification) {
        return notification.get('modifiedTime') > lastCheckedNotifications;
    }).size;
});

var activeNotificationsIdsSelector = exports.activeNotificationsIdsSelector = (0, _reselect.createSelector)(activeNotificationsSelector, function (activeNotifications) {
    return activeNotifications.map(function (notification) {
        return notification.get('id');
    });
});

var notificationUserIdsSelector = exports.notificationUserIdsSelector = (0, _reselect.createSelector)(modifiedElementsSelector, function (modifiedElements, users) {
    return modifiedElements.reduce(function (acc, message) {
        message.get('children').forEach(function (child) {
            var userId = child.get('modifiedBy');
            if (acc.indexOf(userId) === -1) acc.push(userId);
        });

        return acc;
    }, []);
});

var notificationUsersSelector = exports.notificationUsersSelector = (0, _milanoteReselect.createShallowSelector)(notificationUserIdsSelector, function (state) {
    return state.get('users');
}, _immutableHelper.getMany);

var getNotificationUserResources = exports.getNotificationUserResources = (0, _usersSelector.makeFilteredUsersResourcesSelector)(notificationUserIdsSelector);

var errorNotificationUserIds = exports.errorNotificationUserIds = (0, _milanoteReselect.createShallowSelector)(getNotificationUserResources, function (notificationUsers) {
    return notificationUsers.filter(_resourceUtil.isError).keySeq().toArray();
});

var notificationsReadySelector = exports.notificationsReadySelector = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['notifications', 'fetched']);
}, notificationUserIdsSelector, notificationUsersSelector, getNotificationUserResources, function (notificationsFetched, notificationUserIds, notificationUsers, notificationUserResources) {
    return notificationsFetched && notificationUserIds.length === notificationUsers.size && !notificationUserResources.some(_resourceUtil.isFetching) && !notificationUserResources.some(_resourceUtil.isError);
});


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/notificationSelector.js
// module id = 749
// module chunks = 0